import { render, staticRenderFns } from "./EnvironmentalAllergies.vue?vue&type=template&id=48d355d8"
import script from "./EnvironmentalAllergies.vue?vue&type=script&lang=js"
export * from "./EnvironmentalAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports